module.exports = __webpack_public_path__ + "img/contact.8b7e2b6a.svg";